import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
// import { ProjectService } from '../../../common-service/project.service';
import { takeUntil } from 'rxjs';
import { ProductService } from 'src/app/services/product.service';

export interface SelfcaringOrdersData {
  orderId: string;
  orderRaw: any;
  title?: string;
  orderType?: string;
  orderDate?: string;
  orderCompletion?: string;
  orderElement?: any;
  orderItems?: Array<any>;
  actions?: Array<{
    icon?: string;
    label?: string;
    action: (element: any) => void
  }>;
}

export interface OrderSummary{
  total: number,
  subtotal?: number,
  createdDate?: string,
  tax?: number,
  offer?: number,
  offersubtotal?: number,
  offertax?: number
}


@Component({
  selector: 'ngx-selfcaring-orders',
  templateUrl: './selfcaring-orders.component.html',
  styleUrls: ['./selfcaring-orders.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule
  ],
})
export class SelfcaringOrdersComponent implements OnInit{
  @Input() dataOrder?: SelfcaringOrdersData;
  orderId?: string;
  order?: any;
  title: string = 'Ordine';
  loading: boolean = false;
  noOrderFound: boolean = false;
  
  orderSummary?:OrderSummary;
  productsToBuy: any;
  acceptanceType: 'full' | 'splitted' | 'light' = 'full';
  constructor(
    public dialogRef: MatDialogRef<SelfcaringOrdersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productService: ProductService
    // private projectService: ProjectService,
  ) { }
  ngOnInit(): void {
    if (this.dataOrder) {
      this.data = this.dataOrder;
    } 
    if (this.data.title) {
      this.title = this.data.title + ' n°'+ this.data.orderId;
    }
    this.orderId = this.data.orderId;
    let order = this.data.orderRaw;
    let orderItems = this.data.orderItems;
    
    if (this.orderId && order) {
      this.loading = true;
      this.initOrderSummary(order, orderItems).then(() => {
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
    } else {
      // todo gestire messaggio per order id mancante
    }
    
  }

  getOrder(orderId: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      resolve(true)
    })
    
    // '/msc/v1/getorders?order_id=' + this.orderId
    // return new Promise((resolve, reject) => {
    //   this.projectService.getProjectOrderById(orderId).catch(
    //     (err) => {
    //       console.log(err);
    //       this.noOrderFound = true;
    //       reject(false);
    //     }
    //   ).then((data: any) => {
    //     if (data && data.status == "ok" && data.payload) {
    //       console.log(data)
    //       const order = data.payload[0];
    //       this.initOrderSummary(order);
    //       resolve(true);
    //     } else {
    //       this.noOrderFound = true;
    //       reject(false);
    //     }
    //   });
    // })
    
  }
  initOrderSummary(order: any, orderItems: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
    let priceForTEC = order.total;
    let offerForTex =  order.meta_data.find((el: any) => el.key == 'saldo')?.value ?? 0;
    this.acceptanceType = order.meta_data.find((el:any) => el.key === 'contratto_type')?.value ??  'full';
      let order_summary: OrderSummary = {
      createdDate: order.date_created.date,
      total: order.total,
      subtotal: order.total - order.total_tax,
      tax: order.total_tax,
    }

    if (this.acceptanceType != 'full') {
            
      let offer = order.meta_data.find((el: any) => el.key == 'saldoIncludingTax')?.value ?? 0;
      order_summary.offer = offer;
      // let offersubtotal = response.payload[0].meta_data.find((el: any) => el.key == 'saldo')?.value ?? 0;
      order_summary.offersubtotal = offerForTex
      
      order_summary.offertax = offer - offerForTex 
    }
    // this.paymentLink = order.meta_data.find((el: any) => el.key == 'delfi_report_contact_paypal_url')?.value ?? null;
      this.orderSummary = order_summary;
      
      this.productsToBuy = orderItems;

    // this.extractProducts(order).then((res: any) => {
    //   console.log(res);
    //  this.productsToBuy = res;
    // }).catch((err: any) => {
    //   console.log(err);
    //   reject(false)
    // });

    resolve(true);
     })
  }

  extractProducts(order: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let productIds = order.items.reduce((acc:string, curr:any) => {
        return acc + (acc === '' ? '' : ',') + curr.product_id;
      }, '');
      let ids = productIds
      
      
      this.productService.getProductById(ids).then((res: any) => {
          if(res && res.status == 'ok')
          console.log(res.payload.products);
          resolve(res.payload.products);
      }, (err: any) => {
        reject(err)
      })
    })
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }

}
